import { updateStoreTranscriptionStatus } from "../reducers/liveCaption-reducer";
import { LogFirebase } from "../services/firestore";
import liveCaptionService from "../services/liveCaptionService";

/* Call store transcription API */
export const callTranscriptAPIForAISummary = (req) => async (dispatch) => {
    dispatch(updateStoreTranscriptionStatus({ loading: true })); // API start
    try {
        const response = await liveCaptionService.storeTranscriptionDataServiceFunction(req);
        dispatch(updateStoreTranscriptionStatus({ data: response })); // API give success response
        LogFirebase("LiveCaption", "livecaptionStoreAPIResponse", "true");
    } catch (error) {
        LogFirebase("LiveCaption", "livecaptionStoreAPIResponse_error", error || "true");
        dispatch(updateStoreTranscriptionStatus({ error: error || true })); // API give failed response
    }
};
